const cloudServices = [
    { value: 'Google', label: 'Google Cloud' },
    { value: 'Azure', label: 'Microsoft Azure' },
    { value: 'S3', label: 'Amazon S3' },
];

const CloudServicesEnum = {
    S3: "S3",
    Google: "Google",
    Azure: "Azure"
}

export { cloudServices, CloudServicesEnum };